import "./Storymodel.css";
import SSMM1 from "../img/kavitha.png";
import SSMM2 from "../img/sheray.png";
import SSMM3 from "../img/farhan.png";
import SSMM4 from "../img/arun.png";
import userAvatar from "../img/user-avatar.png";
import { useParams } from "react-router-dom";
import { fetchSuccessStoryById } from "../redux/successStorySlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "./Loader";
import { useTranslation } from "react-i18next";
// Inject Google Fonts
const fontLink = document.createElement("link");
fontLink.href =
  "https://fonts.googleapis.com/css2?family=Gloock&family=Poppins:wght@400;500;600&display=swap";
fontLink.rel = "stylesheet";
document.head.appendChild(fontLink);

// ── Update these paths to match your actual image file locations ──


export default function SuccessStoryPage() {
  const {t} = useTranslation();

  const { id } = useParams();
  const dispatch = useDispatch();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(false);
  const allSuccessStories = useSelector((state) => state.successStories.stories);


const couples = [
  {
    names: t("couple1Names"),
    desc: t("couple1Story"),
    img: SSMM1,
  },
  {
    names: t("couple2Names"),
    desc: t("couple2Story"),
    img: SSMM2,
  },
  {
    names: t("couple3Names"),
    desc: t("couple3Story"),
    img: SSMM3,
  },
];
  useEffect(() => {
    setLoading(true);
    dispatch(fetchSuccessStoryById(id)).finally(() => setLoading(false));
  }, [dispatch, id]);

  useEffect(() => {
    console.log("All success stories from store:", allSuccessStories);
    if(allSuccessStories.length > 0) {
      const story = allSuccessStories.find(s => s._id === id);
      console.log("Found story:", story);
      setStory(story);
    }
  }, [allSuccessStories]);



  return (
    <>
      {loading && <Loader />}
      <div className="page1">
        {/* HERO */}
        <section className="hero1">
          <div
            className="back-btn1"
            onClick={() => {
              window.history.back();
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }, 0);
            }}
          >
            ←
          </div>
          <p className="hero-label">Niran Matrimony · Success Story</p>
{/* photos?.url
  ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${photos.url}`
  : userAvatar || "/default-avatar.png" */}
          <div className="hero-photo-wrapper">
            <img 
            src={story?.image ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${story.image}` : userAvatar || "/default-avatar.png"} 
            alt="Divya & Suresh" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = userAvatar;
            }} />
          </div>

          <h1 className="hero-title">{story?.coupleName || ""}</h1>
          <p className="hero-subtitle">
            {t("couple4Story")}
          </p>
        </section>

        {/* STORY CARD */}
        <section className="story-section">
          <div className="story-card1">
            <p className="story-label">{t("couple4Names")}</p>
            <p className="story-text">
              "{story?.description || "Their story is still being written..."}"
            </p>
            <div className="story-divider" />
          </div>
        </section>

        {/* POPULAR POSTS */}
        <section className="popular-section">
          <h2 className="popular-title">{t("popularPosts")}</h2>
          <div className="cards-grid1">
            {couples.map((couple) => (
              <div className="story-card-item" key={couple.names}>
                <div className="card-img-wrapper">
                  <img src={couple.img} alt={couple.names} />
                </div>
                <div className="card-body1">
                  <h3 className="card-title">{couple.names}</h3>
                  <p className="card-desc">{couple.desc}</p>
                  <a href="#" className="card-link">
                    {t("readStory")} →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
